// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ct-status-header {
  margin-bottom: 10px;
}

.ct-review-status {
  border-top: 1px solid #d9d9d9;
  border-bottom: 1px solid #d9d9d9;
  margin: 12px 0 8px;
  padding: 10px 0;
}

.ct-review-status-row {
  display: grid;
  grid-template-columns: minmax(0, 2fr) repeat(5, minmax(0, 1fr));
  gap: 24px;
}

.ct-review-status-stack {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ct-review-status-stack > div {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: baseline;
}

.ct-review-status-label {
  color: #6b6b6b;
  font-size: 12px;
  margin: 0;
}

.ct-review-status-value {
  font-weight: 600;
  margin: 0;
  font-size: 13px;
}`, "",{"version":3,"sources":["webpack://./src/kit/scenes/RightsholderScene/CatalogTransfer/CatalogTransferView/StatusHeader/index.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;;AAEA;EACE,6BAAA;EACA,gCAAA;EACA,kBAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,+DAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AACF;;AAEA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,qBAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;EACA,SAAA;AACF;;AAEA;EACE,gBAAA;EACA,SAAA;EACA,eAAA;AACF","sourcesContent":[".ct-status-header {\n  margin-bottom: 10px;\n}\n\n.ct-review-status {\n  border-top: 1px solid #d9d9d9;\n  border-bottom: 1px solid #d9d9d9;\n  margin: 12px 0 8px;\n  padding: 10px 0;\n}\n\n.ct-review-status-row {\n  display: grid;\n  grid-template-columns: minmax(0, 2fr) repeat(5, minmax(0, 1fr));\n  gap: 24px;\n}\n\n.ct-review-status-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.ct-review-status-stack > div {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  align-items: baseline;\n}\n\n.ct-review-status-label {\n  color: #6b6b6b;\n  font-size: 12px;\n  margin: 0;\n}\n\n.ct-review-status-value {\n  font-weight: 600;\n  margin: 0;\n  font-size: 13px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
